export default "__VITE_ASSET__C8ftXQF6__"